import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, "Megerősítés folyamatban...", -1)

import AuthLayout from "@/components/layout/AuthLayout.vue";
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { InvitationService } from "@/services/InvitationService";


export default /*#__PURE__*/_defineComponent({
  __name: 'RegisterConfirmView',
  setup(__props) {

const route = useRoute();
const invitationService = new InvitationService();

const loading = ref(true);
const success = ref(false);

onMounted(async () => {
  const token = route.query.token as string;
  if (!token) {
    loading.value = false;
    return;
  }
  try {
    await invitationService.confirmEmail(token);
    success.value = true;
  } catch {
    success.value = false;
  } finally {
    loading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(AuthLayout, { "max-width": 480 }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (loading.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_v_progress_circular, {
                indeterminate: "",
                color: "primary",
                class: "mb-4"
              }),
              _hoisted_2
            ], 64))
          : (success.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_v_icon, {
                  color: "success",
                  size: "56",
                  class: "mb-4"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-check-circle")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_title, { class: "justify-center mb-2" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Email cím megerősítve")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Mostantól bejelentkezhet a megadott email címmel.")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  href: "/login",
                  class: "mt-2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Bejelentkezés")
                  ]),
                  _: 1
                })
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createVNode(_component_v_icon, {
                  color: "error",
                  size: "56",
                  class: "mb-4"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-alert-circle")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_title, { class: "justify-center mb-2" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Érvénytelen link")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createTextVNode("A megerősítő link érvénytelen vagy lejárt.")
                  ]),
                  _: 1
                })
              ], 64))
      ])
    ]),
    _: 1
  }))
}
}

})